import { openDB } from 'idb';
let mapTilesDB = null;
const initMapTilesDB = async () => {
    if (!mapTilesDB) {
        mapTilesDB = await openDB('mapTilesDB', 1, {
            upgrade(db) {
                if (!db.objectStoreNames.contains('tiles')) {
                    db.createObjectStore('tiles');
                }
                if (!db.objectStoreNames.contains('metadata')) {
                    db.createObjectStore('metadata');
                }
                if (!db.objectStoreNames.contains('assets')) {
                    db.createObjectStore('assets');
                }
            },
        });
    }
    return mapTilesDB;
};
// Helper to create tile key from coordinates
export const getTileKey = (coords) => {
    return `${coords.z}/${coords.x}/${coords.y}`;
};
export const MAP_TILES_DB = {
    SET: {
        async tile(coords, data) {
            const db = await initMapTilesDB();
            const key = getTileKey(coords);
            await db.put('tiles', data, key);
        },
        async asset(assetKey, data) {
            const db = await initMapTilesDB();
            await db.put('assets', data, assetKey);
        },
        async tiles(tilesData) {
            const db = await initMapTilesDB();
            const tx = db.transaction('tiles', 'readwrite');
            await Promise.all(tilesData.map((item) => {
                const key = getTileKey(item.coords);
                return tx.store.put(item.data, key);
            }));
            await tx.done;
        },
        async metadata(rallyId, metadata) {
            const db = await initMapTilesDB();
            await db.put('metadata', {
                rallyId,
                ...metadata,
                cachedAt: Date.now(),
            }, `rally-${rallyId}`);
        },
    },
    GET: {
        async tile(coords) {
            const db = await initMapTilesDB();
            const key = getTileKey(coords);
            return (await db.get('tiles', key)) ?? null;
        },
        async metadata(rallyId) {
            const db = await initMapTilesDB();
            return (await db.get('metadata', `rally-${rallyId}`)) ?? null;
        },
        async allTileKeys() {
            const db = await initMapTilesDB();
            return await db.getAllKeys('tiles');
        },
        async tileCount() {
            const db = await initMapTilesDB();
            const keys = await db.getAllKeys('tiles');
            return keys.length;
        },
        async asset(assetKey) {
            const db = await initMapTilesDB();
            return (await db.get('assets', assetKey)) ?? null;
        },
    },
    DELETE: {
        async tile(coords) {
            const db = await initMapTilesDB();
            const key = getTileKey(coords);
            await db.delete('tiles', key);
        },
        async allTiles() {
            const db = await initMapTilesDB();
            await db.clear('tiles');
        },
        async rallyMetadata(rallyId) {
            const db = await initMapTilesDB();
            await db.delete('metadata', `rally-${rallyId}`);
        },
        async allMetadata() {
            const db = await initMapTilesDB();
            await db.clear('metadata');
        },
    },
    CLEAR: {
        async all() {
            const db = await initMapTilesDB();
            await db.clear('tiles');
            await db.clear('metadata');
            await db.clear('assets');
        },
    },
};
